import styled, { CSSProperties, keyframes } from 'styled-components'

type ScrollingTextProps = {
  duration: CSSProperties['animationDuration']
  delay: CSSProperties['animationDelay']
  iterationCount: CSSProperties['animationIterationCount']
  direction: CSSProperties['animationDirection']
}

const scroll = keyframes`
  0% {
    transform: translateX(100%);
  }

  100% {
    transform: translateX(-100%);
  }
`

export const Container = styled.div`
  display: flex;
  overflow-x: hidden;
  width: 100%;
`

export const ScrollingText = styled.div<ScrollingTextProps>`
  display: flex;
  align-items: center;
  flex: 0 0 auto;

  min-width: 100%;

  animation-name: ${scroll};
  animation-duration: ${({ duration }) => duration};
  animation-timing-function: linear;
  animation-iteration-count: ${({ iterationCount }) => iterationCount};
  animation-direction: ${({ direction }) => direction};
  animation-delay: ${({ delay }) => delay};
  animation-play-state: running;
`
